// @ts-check

/**
 * @readonly
 * @enum {number}
 */
export const WebErrorCodeEnum = {
    Unknown: 0,
    IOError: 1,

    LoginPasswordFailed: 400,
    LoginUserFailedAndBlocked: 401,
    LoginAdminFailedAndBlocked: 402,
    LoginUserBlocked: 403,
    LoginAdminBlocked: 404,
    
    DmsisNotWorkingError: 500,
    ConverterNotWorkingError: 501,

    UserNotExistsError: 1000,

    DeviceCodeNotExistsError: 1100,
    DeviceCodeExistsError: 1101,
    DeviceCodeLockedError: 1102,

    InformingEmailValidationError: 2100,
    InformingFromEmailValidationError: 2101,
    SupportEmailValidationError: 2102,

    ExternalSmrUrlSettingEmptyError: 2300,

    UserSyncAlreadyStarted: 2400
}

/**
 * @readonly
 * @enum {number}
 */
export const UserTaskEnum = {
    None: 0,
    WaitInSyncQueue: 13,
    LoadDocumentsList: 12,
    LoadDictionaries: 1,
    LoadDocuments: 2,
    RemoveConsiderationDocuments: 18,
    RemovingUser: 3,
    RemovingUserDl: 16,
    RemovingUserPhysically: 17,
    LoadVisaDocuments: 4,
    RemoveVisaDocuments: 5,
    LoadSignDocuments: 6,
    RemoveSignDocuments: 7,
    LoadControlDocuments: 8,
    RemoveControlDocuments: 9,
    LoadUserFolders: 10,
    RemoveUserFolders: 11,
    LoadProjectDocuments: 14,
    RemoveProjectDocuments: 15,
    LoadMeetings: 19,
    RemoveMeetings: 20
}

/**
 * @readonly
 * @enum {number}
 */
export const BackgroundTaskStatusEnum = {
    None: 0,
    InProgress: 1,
    Completed: 2,
    WasError: 3,
    DmsisDoesNotWorking: 4,
    Cancelled: 5
}

/**
 * @readonly
 * @enum {number}
 */
export const PushStateEnum = {
    Ok: 0,
    PushDisabled: 1,
    AuthKeyMissed: 2,
    PushFault: 3
}

/**
 * @readonly
 * @enum {number}
 */
export const DbRequestStatusEnum = {
    Pending: 0,
    Success: 1,
    Aborted: 2,
    None: 3
}

/**
 * @readonly
 * @enum {number}
 */
export const ProtocolEventSuccessTypeEnum = {
    Success: 1,
    Warning: 2,
    Error: 3
}